export const PUBLISH_TYPES = {
  MODERATED: 'moderated',
  AUTOMATIC: 'automatic',
};
